import React from "react";
import GoogleMapReact from "google-map-react";
import LocationMarker from "./LocationMarker";

// geocoder = Geocoder()
// const georesult = geocode(request)

// console.log(georesult)

// const georesult = "https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=AIzaSyAg6wSKhb0R2QN4lu69PpWK50z5eks4WFU"

async function get_geocoding(addres) {

  let base_url = 'https://maps.googleapis.com/maps/api/geocode/json?';
  let full_url = base_url + new URLSearchParams({
    address: addres,
    key: "AIzaSyAg6wSKhb0R2QN4lu69PpWK50z5eks4WFU"
  })

  let options = {
    method: 'GET',
    headers: { Accept: 'application/json', }
  };

  const res = await fetch(full_url, options)
  const json = await res.json()
  let { lat, lng } = json["results"][0]["geometry"]["location"]
  return { lat, lng }
}

const listings = [
  {
    key: "test2343",
    lat: 45.3265,
    lng: -125.8756,
  }, {
    key: "test2123",
    lat: 33.3265,
    lng: -110.8756,
  }, {
    key: "test222",
    lat: 40.3265,
    lng: -120.8756,
  }, {
    key: "test232",
    lat: 34.3265,
    lng: -118.8756,
  },{
    key: "test2232",
    lat: 41.3265,
    lng: -122.8756,
  },{
    key: "test232",
    lat: 32.3265,
    lng: -113.8756,
  },{
    key: "test232",
    lat: 39.3265,
    lng: -118.8756,
  },{
    key: "test232",
    lat: 32.3265,
    lng: -111.8756,
  },{
    key: "test21234",
    lat: 39.822763,
    lng: -8.8756,
  }, {
    key: "test232",
    lat: 34.65,
    lng: -117.8756,
  },{
    key: "test232",
    lat: 34.265,
    lng: -118.756,
  },{
    key: "test232",
    lat: 35.265,
    lng: -117.756,
  },{
    key: "test232",
    lat: 35.965,
    lng: -117.956,
  },{
    key: "test232",
    lat: 35.265,
    lng: -116.756,
  },{
    key: "test232",
    lat: 34.265,
    lng: -116.756,
  },{
    key: "test232",
    lat: 35.265,
    lng: -116.756,
  },{
    key: "test232",
    lat: 35.265,
    lng: -116.056,
  },{
    key: "test232",
    lat: 36.265,
    lng: -116.056,
  },{
    key: "test232",
    lat: 38.265,
    lng: -115.056,
  },{
    key: "test232",
    lat: 43.3265,
    lng: -79.8756,
  },{
    key: "test232",
    lat: 42.3265,
    lng: -78.8756,
  },{
    key: "test232",
    lat: 42.3265,
    lng: -77.8756,
  },{
    key: "test232",
    lat: 40.3265,
    lng: -75.8756,
  },{
    key: "test232",
    lat: 40.3265,
    lng: -90.8756,
  },{
    key: "test232",
    lat: 34.3265,
    lng: -110.8756,
  },{
    key: "test232",
    lat: 35.3265,
    lng: -8.8756,
  },{
    key: "test232",
    lat: 44.3265,
    lng: -75.8756,
  },]


const Map = ({ center, zoom }) => {
  get_geocoding("330 de neve dr").then((res) => console.log(res))

  const markers = listings.map(listing => {
    console.log(listing)
    return <LocationMarker key={listing.key} lat={listing.lat} lng={listing.lng} />
  })
  console.log(markers)


  return (
    // Important! Always set the container height explicitly
    <div className="map" style={{ height: "80vh", width: "100%" }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyBVvoSnslqAIfAKty8aFAm8O9UhBZGRO7k" }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        {/* <AnyReactComponent
          lat={59.955413}
          lng={30.337844}
          text="My Marker"
        /> */}  
        {listings.map((listing) => {
          return <LocationMarker key={listing.key} lat={listing.lat} lng={listing.lng} />
        })}
        {/* 
      <LocationMarker lat={center.lat} lng={center.lng}/>
      <LocationMarker lat={72.3265} lng={72.3265}/> */}
      </GoogleMapReact>
    </div>
  );
};

Map.defaultProps = {
  center: {
    lat: 36.3265,
    lng: -115.8756,
  },
  zoom: 6,
};

export default Map;
